import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  outlined: {
    '&.MuiButton-outlinedSecondary': {
      '&, &[disabled], &.Mui-disabled': {
        borderColor: SecondaryColors.main,
        color: TextColors.light,

        '&:hover': {
          borderColor: SecondaryColors.light,
          backgroundColor: hexToRGBA(SecondaryColors.main, 0.15),
        },
      },
    },
  },

  link: {
    '&.MuiLink-root, &.MuiButton-root': {
      '&, &[disabled], &.Mui-disabled': {
        color: SecondaryColors.main,

        '&:hover': {
          color: SecondaryColors.light,
        },
      },
    },
  },
};

const lightTheme = {
  outlined: {
    '&.MuiButton-outlinedSecondary': {
      '&, &[disabled], &.Mui-disabled': {
        borderColor: SecondaryColors.dark,
        color: TextColors.dark,

        '&:hover': {
          borderColor: SecondaryColors.main,
          backgroundColor: hexToRGBA(SecondaryColors.main, 0.15),
        },
      },
    },
  },
  link: {
    '&.MuiLink-root, &.MuiButton-root': {
      '&, &[disabled], &.Mui-disabled': {
        color: SecondaryColors.dark,

        '&:hover': {
          color: SecondaryColors.main,
        },
      },
    },
  },
};

const styles = createStyles<any, any>({
  button: {
    '&.MuiButton-root': {
      minWidth: '150px',
      textAlign: 'center',
    },

    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
  contained: {
    '&.MuiButton-containedSecondary': {
      '&, &[disabled], &.Mui-disabled': {
        backgroundColor: SecondaryColors.main,
        color: TextColors.dark,

        '&:hover': {
          backgroundColor: SecondaryColors.light,
        },
      },
    },
  },
  outlined: {
    '&.dark-theme': darkTheme.outlined,
    '&.light-theme': lightTheme.outlined,
  },
  link: {
    '&.dark-theme': darkTheme.link,
    '&.light-theme': lightTheme.link,

    '&.Mui-disabled': {
      opacity: 0.5,
    },

    '&.MuiLink-root': {
      '&:hover': {
        textDecoration: 'none',
        cursor: 'pointer',
      },
    },

    '& .MuiSvgIcon-root': {
      '&:first-child': {
        display: 'inherit',
        marginRight: '8px',
        marginLeft: '-4px',
      },

      '&:last-child': {
        display: 'inherit',
        marginLeft: '8px',
        marginRight: '-4px',
      },
    },
  },
  link__dark: darkTheme.link,
  link__light: lightTheme.link,
});

export default makeStyles(styles, { name: 'GenButton' });
